import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/Devops.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardDevOps from "../components/core/Course/CourseDetailsCardDevOps";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                  DevOps Foundation Training & Certification
                </p>
              </div>

              <p className={`text-richblue-500`}>
                With the increasing demand for streamlined software delivery and operational efficiency, DevOps has become a cornerstone of modern IT practices. This course is meticulously crafted to equip professionals with a comprehensive understanding of DevOps principles, methodologies, and tools.
                By mastering DevOps practices, participants can drive innovation, enhance system reliability, and accelerate time-to-market, ensuring a competitive edge in today’s fast-paced digital landscape.
              </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardDevOps />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s rapidly evolving technological landscape, organizations are under constant pressure to deliver software faster while maintaining system stability and reliability. The growing complexity of IT systems and the increasing frequency of changes have made it essential for teams to adopt practices that ensure seamless collaboration between development and operations."
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The DevOps Foundation Certification is designed to address these challenges by providing professionals with a solid understanding of DevOps principles, practices, and tools. This course empowers teams to break down silos, automate workflows, and implement continuous integration and delivery (CI/CD) pipelines. By fostering a culture of collaboration and shared responsibility, DevOps enables organizations to accelerate innovation, improve system reliability, and deliver value to customers more efficiently."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Understand and implement the core principles and best practices of DevOps.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Utilize DevOps tools and techniques to streamline development and operations workflows.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Integrate DevOps practices into existing organizational frameworks for seamless adoption.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Enhance operational efficiency through automation, continuous integration, & continuous delivery.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Reduce costs while improving system reliability and scalability.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Build, deploy, and manage complex applications with greater agility and efficiency.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Foster collaboration and communication between development, operations, and other stakeholders.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName={"Module 1: Introduction to DevOps"}
                courseList={[
                  "Purpose",
                  "Objectives",
                  "The business value of DevOps",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 2: DevOps Principles"}
                courseList={[
                "Core principles of DevOps",
                "The Three Ways: Flow, Feedback, and Continuous Learning",
                "Collaboration and shared responsibility",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 3: DevOps and Other Frameworks"}
                courseList={[
                "Understanding Agile, Lean, and ITSM frameworks",
                "How DevOps complements Agile and Lean methodologies",
                "Integrating DevOps with IT Service Management (ITSM)",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />{" "}
              <CourseAccordionBar
                courseName={"Module 4: DevOps Culture"}
                courseList={[
                "Building a collaborative and inclusive DevOps culture",
                "Breaking down silos between teams",
                "Encouraging a mindset of shared ownership",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 5: DevOps Roles and Organizational Considerations"}
                courseList={[
                "Key roles in a DevOps environment",
                "Responsibilities of DevOps engineers, developers, and operations teams",
                "Organizational structures that support DevOps",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 6: DevOps Practices"}
                courseList={[
                "Continuous Integration (CI) and Continuous Delivery (CD)",
                "Infrastructure as Code (IaC)",
                "Monitoring, logging, and observability",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 7: DevOps and Automation"}
                courseList={[
                  "Common DevOps practices and related processes",
                  "Patterns for SRE Adoption",
                  "Sustainable Incident Response",
                  "Blameless Post-Mortems",
                  "SRE & Scale",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 8: Adopting DevOps"}
                courseList={[
                "Steps to implement DevOps in an organization",
                "Assessing organizational readiness for DevOps",
                "Creating a DevOps roadmap and strategy",
                "Measuring success with DevOps metrics and KPIs",
                "Overcoming common challenges in DevOps adoption",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
